module.exports = __webpack_public_path__ + "static/media/double-hamb.cf6c9ef2.webp";